import { getAudioGraph } from './get-audio-graph';
import { getValueForKey } from './get-value-for-key';
export function getAudioParamConnections(context, audioParam) {
    const audioGraph = getAudioGraph(context);
    return getValueForKey(audioGraph.params, audioParam);
}
//# sourceMappingURL=/build/es2018/helpers/get-audio-param-connections.js.map